var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0643 11.8923H15.6557C14.4864 11.8923 13.3651 12.3568 12.5383 13.1836C11.7115 14.0104 11.2471 15.1317 11.2471 16.3009V42.7526C11.2471 43.9218 11.7115 45.0431 12.5383 45.8699C13.3651 46.6967 14.4864 47.1612 15.6557 47.1612H37.6987C38.8679 47.1612 39.9893 46.6967 40.816 45.8699C41.6428 45.0431 42.1073 43.9218 42.1073 42.7526V16.3009C42.1073 15.1317 41.6428 14.0104 40.816 13.1836C39.9893 12.3568 38.8679 11.8923 37.6987 11.8923H33.2901",
    stroke: "#00793A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8817 7.48364H24.4731C22.0383 7.48364 20.0645 9.45744 20.0645 11.8922C20.0645 14.327 22.0383 16.3008 24.4731 16.3008H28.8817C31.3165 16.3008 33.2903 14.327 33.2903 11.8922C33.2903 9.45744 31.3165 7.48364 28.8817 7.48364Z",
    stroke: "#00793A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0645 31.7309L24.4731 36.1395L33.2903 27.3223",
    stroke: "#00793A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCheck);
export default __webpack_public_path__ + "static/media/clipboardCheck.57b9f3a9.svg";
export { ForwardRef as ReactComponent };